import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { BYPASS_XSRF_AUTH_INTERCEPTOR } from '../../app.module';

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Check if request should bypass XSRF
    if (request.context.get(BYPASS_XSRF_AUTH_INTERCEPTOR)) {
      return next.handle(request);
    }

    // Get XSRF token from cookie
    const xsrfToken = this.cookieService.get('XSRF-TOKEN');

    // If token exists, add it to headers
    if (xsrfToken) {
      const clonedRequest = request.clone({
        setHeaders: {
          'X-XSRF-TOKEN': xsrfToken
        }
      });
      return next.handle(clonedRequest);
    }

    // No token found, proceed without header
    return next.handle(request);
  }
}
